import { TokenList } from "../../store/global/getAllTokenLists";
import { Token } from "../../store/global/TokenEnum";
import { CounterParty } from "../tradeUtils";
import { Balances } from "../../store/global/getBalancesFast";
import { Hash } from "viem";

enum FilterSuccessReason {
  SearchIsSymbolSubstr = "SearchIsSymbolSubstr",
  SearchIsNameSubstr = "SearchIsNameSubstr",
  SearchIsContractAddress = "SearchIsContractAddress",
}
export const getSearchFilterSuccessReason = ({
  symbol,
  name,
  contractAddress,
  searchString,
}: {
  symbol: Token;
  name: string;
  contractAddress: Hash;
  searchString: string;
}) => {
  if (searchString === "") return true;
  const symbolLowerCase = symbol.toLowerCase();
  const nameLowerCase = name.toLowerCase();
  const stringLowerCase = searchString.toLowerCase();
  const contractAddressLowered = contractAddress.toLowerCase();

  if (symbolLowerCase.includes(stringLowerCase)) {
    return FilterSuccessReason.SearchIsSymbolSubstr;
  } else if (nameLowerCase.includes(stringLowerCase)) {
    return FilterSuccessReason.SearchIsNameSubstr;
  } else if (searchString.toLowerCase() === contractAddressLowered) {
    return FilterSuccessReason.SearchIsContractAddress;
  }
  return null;
};
export const getAutoCompleteString = (
  searchString: string,
  tokenList: TokenList | undefined,
  tokensToShow: Array<Token>
) => {
  if (searchString.length > 0 && tokenList != null && tokensToShow?.[0] != null) {
    const searchStringLowerCase = searchString.toLowerCase();
    const symbol = tokensToShow[0];
    const name = tokenList[symbol]?.name ?? "";
    const contractAddress = (tokenList[symbol]?.chainInfo.contractAddress as Hash) ?? "";
    const searchFilterSuccessReason = getSearchFilterSuccessReason({
      symbol,
      name,
      contractAddress,
      searchString,
    });
    if (
      searchFilterSuccessReason === FilterSuccessReason.SearchIsSymbolSubstr &&
      searchStringLowerCase === symbol.slice(0, searchString.length).toLowerCase()
    ) {
      return searchString + symbol.slice(searchString.length);
    } else if (
      searchFilterSuccessReason === FilterSuccessReason.SearchIsNameSubstr &&
      searchStringLowerCase === name.slice(0, searchString.length).toLowerCase()
    ) {
      return searchString + name.slice(searchString.length);
    }
  }
};

export const getPlaceholder = (
  counterParty: CounterParty,
  isInFocus: boolean,
  isFirstInCounterparty: boolean
) => {
  if (isInFocus || !isFirstInCounterparty) return "Search for token";
  if (counterParty === "taker") return "Trade this...";
  return "to that...";
};

export const getSortedTokensList = (
  unselectedTokens: Array<Token>,
  tokenList: TokenList | undefined,
  sortedBalances: Balances,
  searchString: string
) => {
  if (tokenList == null) return null;
  const unselectedTokensSet = new Set(unselectedTokens); // filteredTokens is an array of tokens without tokens that are already selected
  return sortedBalances
    .filter(entry => unselectedTokensSet.has(entry.symbol))
    .map(entry => ({
      symbol: entry.symbol,
      name: tokenList[entry.symbol]?.name ?? "",
      contractAddress: (tokenList[entry.symbol]?.chainInfo.contractAddress as Hash) ?? "",
    }))
    .filter(
      ({ symbol, name, contractAddress }) =>
        getSearchFilterSuccessReason({ symbol, name, contractAddress, searchString }) != null
    )
    .map(entry => entry.symbol);
};
